/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SubmitOnboardingSurveyRequestBody,
  SubmitOnboardingSurveyRequestBody$Outbound,
  SubmitOnboardingSurveyRequestBody$outboundSchema,
} from "../components/submitonboardingsurveyrequestbody.js";

export type SubmitOnboardingSurveySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SubmitOnboardingSurveyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  submitOnboardingSurveyRequestBody: SubmitOnboardingSurveyRequestBody;
};

/** @internal */
export type SubmitOnboardingSurveySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SubmitOnboardingSurveySecurity$outboundSchema: z.ZodMiniType<
  SubmitOnboardingSurveySecurity$Outbound,
  SubmitOnboardingSurveySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function submitOnboardingSurveySecurityToJSON(
  submitOnboardingSurveySecurity: SubmitOnboardingSurveySecurity,
): string {
  return JSON.stringify(
    SubmitOnboardingSurveySecurity$outboundSchema.parse(
      submitOnboardingSurveySecurity,
    ),
  );
}

/** @internal */
export type SubmitOnboardingSurveyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SubmitOnboardingSurveyRequestBody: SubmitOnboardingSurveyRequestBody$Outbound;
};

/** @internal */
export const SubmitOnboardingSurveyRequest$outboundSchema: z.ZodMiniType<
  SubmitOnboardingSurveyRequest$Outbound,
  SubmitOnboardingSurveyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    submitOnboardingSurveyRequestBody:
      SubmitOnboardingSurveyRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      submitOnboardingSurveyRequestBody: "SubmitOnboardingSurveyRequestBody",
    });
  }),
);

export function submitOnboardingSurveyRequestToJSON(
  submitOnboardingSurveyRequest: SubmitOnboardingSurveyRequest,
): string {
  return JSON.stringify(
    SubmitOnboardingSurveyRequest$outboundSchema.parse(
      submitOnboardingSurveyRequest,
    ),
  );
}
